import { useCallback } from 'react';
import { InvoiceDetailModel, InvoiceModel, InvoiceStatus } from '@frontend/api-invoices';
import { useLatencyBustPoll } from '@frontend/payments-hooks';
import { useGetInvoiceNonQuery, useUpdateInvoiceQueryCache } from '@frontend/payments-invoice-controller';

export const useUpdatePaidRequestPoll = <T extends InvoiceModel | undefined = InvoiceModel>(
  unpaidInvoice: T,
  onSuccessCallback: (updatedInvoice: InvoiceDetailModel) => void
) => {
  const getInvoice = useGetInvoiceNonQuery(unpaidInvoice?.id);
  const updateInvoiceCache = useUpdateInvoiceQueryCache(unpaidInvoice?.id);

  const { getPollPromise } = useLatencyBustPoll({
    queryMethod: getInvoice,
    onPollEnd: (data) => {
      updateInvoiceCache(data);
      onSuccessCallback(data);
    },
    accessor: (data) => {
      return data?.status;
    },
  });

  const setProcessingAndStartPoll = useCallback(() => {
    if (unpaidInvoice) {
      getPollPromise(unpaidInvoice);
      updateInvoiceCache({ ...unpaidInvoice, status: 'Processing' as InvoiceStatus });
    }
  }, [unpaidInvoice, getPollPromise]);

  return { setProcessingAndStartPoll };
};
